// NPM Imports
import React from 'react'
// Quote Context
import { useQuoteContext } from '../../../hooks/useQuoteContext'
import { productType } from '../../../types/types'
//@ts-ignore
import { MultiProductDropdownTable } from '../../ui-helper-elements'

function ConsultingServicesTable() {
   //TODO: change this to the proper typing once we migrate App.jsx to Typescript
   const state = useQuoteContext()
   const { getString } = state

   // Filter the product list to get only the Professional Services products with monthly billing frequency sorted by DisplayOrder
   const serviceList = (Object.values(state.product_list) as productType[])
      .filter(
         (product) =>
            product.ProductFamily === 'Consulting Services' &&
            product.BillingFreq === 'once',
      )
      .sort(
         (a: productType, b: productType) =>
            (a.DisplayOrder ?? 0) - (b.DisplayOrder ?? 0),
      )

   if ((state?.consultingServiceDetails?.length ?? 0) > 0) {
      return (
         <MultiProductDropdownTable
            tableTitle={getString('product.ConsultingServicesTable.TableTitle')}
            productList={serviceList}
            detailsList={state.consultingServiceDetails}
            handleDetailsChange={(updatedList) =>
               state.setConsultingServiceDetails(
                  updatedList as {
                     serviceCode: string
                     count: number
                     [key: string]: string | number
                  }[],
               )
            }
            codeField='serviceCode'
            currencyObject={state.currencyObject}
            quantityStep={0.5}
         />
      )
   }
}

export default ConsultingServicesTable
